<div id="wrapper">
  <div class="allcont">
    <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
    <div>
      <app-tab-nav (updateType)="this.type=$event" (updatePostpaid)="this.postpago=$event"
                   (updatePrepaid)="this.prepago=$event" (updateFixed)="this.telefoniaFijo=$event"
                   (updateTotalAccountList)="this.totalAccountList=$event" (updateCurrentList)="this.currentList=$event"
                   (updateSelectBan)="this.selectBan=$event" (updateInitializeData)="this.initializeData()">
      </app-tab-nav>
    </div>
    <div class="basicrow mbott">
      <div class="container">
        <div class="fulltitle m-top-i f-btitle autodef">
          <span class="icon-dash-13"></span> Preguntas Frecuentes
        </div>
        <app-collapse [(content)]="this.content"></app-collapse>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
